const initState = {
    searchTerm: '',
    awaitSearch: false,
    searchEnded: false,
    hasSearched: false,
}

const searchReducer = (state = initState, action) => {
    
    switch(action.type){
        case 'CHANGE_AWAIT_SEARCH': {
            state = {
                ...state,
                awaitSearch: action.value
            }
            break;
        }
        case 'SEARCH_ENDED': {
            state = {
                ...state,
                searchEnded: action.value
            }
            break;
        }
        case 'SEARCH_STARTED': {
            state = {
                ...state,
                searchTerm: action.term,
                hasSearched: true,
            }
            break;
        }
    }
    
    return state
}

export default searchReducer;
